import * as core from 'cw-ui-core';
import getScreen from 'src/ScreenFactory';

const Routes = {
    HOME: {
        id: 'home',
        path: '/',
        exact: true,
        component: getScreen('home'),
        icon: 'Object_HomeAutomation',
        showInMenu: true,
        name: () => 'Home',
    },
    PARTNERS: {
        id: 'partners',
        path: '/partners',
        exact: true,
        component: getScreen('partners'),
        icon: 'Menu_Companies',
        showInMenu: true,
        name: () => 'Partners List',
    },
    PARTNER: {
        id: 'partner',
        path: '/partners/:partnerId',
        exact: true,
        regex: '/partners/' + core.REGEX_ANYTHING_MATCH,
        component: getScreen('partner'),
    },
    PARTNER_TAB: {
        id: 'partner',
        path: '/partners/:partnerId/:tab',
        regex: '/partners/' + core.REGEX_ANYTHING_MATCH + '?/:tab',
        component: getScreen('partner'),
    },
    TRANSACTIONS: {
        id: 'transactions',
        path: '/transactions',
        exact: true,
        component: getScreen('transactions'),
        name: () => 'Transactions List',
    },
    SCHEDULED_TRANSACTIONS: {
        id: 'scheduled_transactions',
        path: '/scheduledtransactions',
        exact: true,
        component: getScreen('scheduledtransactions'),
        name: () => 'Scheduled Transactions List',
    },
    CREDIT_CARDS: {
        id: 'credit_cards',
        path: '/creditcards',
        exact: true,
        component: getScreen('creditCards'),
        name: () => 'Credit Card List',
    },
    USERS: {
        id: 'users',
        path: '/users',
        exact: true,
        component: getScreen('users'),
        name: () => 'Users',
        icon: 'Object_Group',
        showInMenu: true,
    },
    USER: {
        id: 'user',
        path: '/users/:partnerId/user/:userId',
        exact: true,
        regex: '/users/' + core.REGEX_ANYTHING_MATCH + '/user/' + core.REGEX_ANYTHING_MATCH,
        component: getScreen('user'),
    },
    // Product Catalog Tab Routes - must come before PRODUCT route to match first
    PRODUCTS_MARKETPLACE: {
        id: 'products',
        path: '/products/marketplaceproducts',
        exact: true,
        component: getScreen('products'),
        showInMenu: false,
    },
    PRODUCTS_PACKAGES: {
        id: 'products',
        path: '/products/packages',
        exact: true,
        component: getScreen('products'),
        showInMenu: false,
    },
    PRODUCTS_ENTITLEMENTS: {
        id: 'products',
        path: '/products/entitlements',
        exact: true,
        component: getScreen('products'),
        showInMenu: false,
    },
    PRODUCTS_ENTITLEMENT_MANAGEMENT: {
        id: 'products',
        path: '/products/entitlementmanagement',
        exact: true,
        component: getScreen('products'),
        showInMenu: false,
    },
    PRODUCTS_ENTITLEMENT_MANAGEMENT_AUDITLOGS: {
        id: 'products',
        path: '/products/entitlementmanagement/auditlogs',
        exact: true,
        component: getScreen('products'),
        showInMenu: false,
    },
    PRODUCT: {
        id: 'product',
        path: '/products/:productId',
        exact: true,
        regex: '/products/' + core.REGEX_ANYTHING_MATCH,
        component: getScreen('product'),
    },
    PRODUCT_TAB: {
        id: 'product',
        path: '/products/:productId/:tab',
        exact: true,
        regex: '/products/' + core.REGEX_ANYTHING_MATCH + '?/:tab',
        component: getScreen('product'),
    },
    INSTANCES: {
        id: 'instances',
        path: '/instances/:tab',
        exact: true,
        regex: '/instances/' + core.REGEX_ANYTHING_MATCH,
        component: getScreen('instances'),
        name: () => 'Package & Product Instance List',
        icon: 'Workspace',
        showInMenu: true,
    },
    PRODUCT_INSTANCES: {
        id: 'product_instances',
        path: '/productinstances',
        exact: true,
        component: getScreen('productInstances'),
        name: () => 'Product Instance List',
        showInMenu: false,
    },
    PRODUCT_INSTANCE: {
        id: 'product_instance',
        path: '/productinstance/:instanceId',
        regex: '/productinstance/' + core.REGEX_ANYTHING_MATCH,
        exact: true,
        component: getScreen('productInstance'),
        showInMenu: false,
    },
    COMPANY: {
        id: 'company',
        path: '/companies/:companyId',
        component: getScreen('company'),
        showInMenu: false,
    },
    CLIENTS: {
        id: 'clients',
        path: '/clients',
        exact: true,
        component: getScreen('clients'),
        showInMenu: false,
    },
    CLIENT: {
        id: 'client',
        path: '/clients/:partnerId/client/:clientId',
        exact: true,
        component: getScreen('client'),
        name: () => 'Client Detail',
        showInMenu: false,
    },
    PROVISION_PLATFORM: {
        id: 'provision_platform',
        path: '/partner/:partnerId/provisionplatform',
        component: getScreen('provisionplatform'),
        name: () => 'Provision Platform',
        showInMenu: false,
    },
    PROVISION_GOOD_BMS: {
        id: 'provision_good_bms',
        path: '/partner/:partnerId/provisionplatformessentials',
        component: getScreen('provisionplatformessentials'),
        name: () => 'Provision ConnnectWise Platform Essentials',
        showInMenu: false,
    },
    PROVISION_PRODUCT: {
        id: 'provision_product',
        path: '/partner/:partnerId/provisionProduct',
        component: getScreen('provisionProduct'),
        name: () => 'Provision Product',
        showInMenu: false,
    },
    PRODUCTS: {
        id: 'products',
        path: '/products',
        exact: true,        
        component: getScreen('products'),
        icon: 'Application_CW_Marketplace',
        showInMenu: true,
        name: () => 'Product Catalog',
    },
    PROVISION_STATUS: {
        id: 'provision_status',
        path: '/partner/:partnerId/provision/status',
        component: getScreen('provisionStatus'),
        name: () => 'Provision Status',
        showInMenu: false,
    },
    GOOD_BMS_TRIAL_PAGE: {
        id: 'GOOD_BMS_TRIAL_PAGE',
        path: '/partner/:partnerId/GOODBMSTRIALPAGE',
        exact: true,
        component: getScreen('GOODBMSTRIALPAGE'),
        //icon: 'Menu_Companies',
        showInMenu: false,
        name: () => 'Good BMS',
    },
    PACKAGES: {
        id: 'packages',
        path: '/products',
        exact: true,
        component: getScreen('products'),
        showInMenu: false,
    },
    PACKAGE: {
        id: 'package',
        path: '/package/:packageId',
        exact: true,
        component: getScreen('packageDetail'),
        showInMenu: false,
    },
    PACKAGE_TAB: {
        id: 'package',
        path: '/package/:packageId/:tab',
        regex: '/package/' + core.REGEX_ANYTHING_MATCH + '?/:tab',
        component: getScreen('packageDetail'),
    },
    AUDITLOGS: {
        id: 'auditlogs',
        path: '/auditlogs',
        exact: true,
        component: getScreen('auditlogs'),
        showInMenu: false,
        name: () => 'Audit Logs',
    },
    PRODUCTAUDITLOGS: {
        id: 'productauditlogs',
        path: '/productauditlogs',
        exact: true,
        component: getScreen('productauditlogs'),
        showInMenu: false,
        name: () => 'Product Audit Logs',
    },
    PACKAGEAUDITLOGS: {
        id: 'packageauditlogs',
        path: '/packageauditlogs',
        exact: true,
        component: getScreen('packageauditlogs'),
        showInMenu: false,
        name: () => 'Package Audit Logs',
    },
     SSO_ACCOUNT: {
        id: 'ssoaccount',
        path: '/ssoaccount',
        exact: true,        
        component: getScreen('ssoaccount'),
        icon: 'Action_AddCustomer',
        showInMenu: true,
        name: () => 'SSO Account',
    },
};

export default Routes;